import { Box, Button, Flex, Image, Text } from "@chakra-ui/react"

import checkIcon from "#/assets/check.svg"
import {
  selectDepositActionMigrationStatus,
  selectDepositActionToken,
  selectDepositActionUserAmount,
  useDappSelector,
} from "#/redux-state"
import TokenLabel from "#/shared/components/TokenLabel"
import { DepositMigrationStatus } from "#/shared/types"
import { getTokenIcon } from "#/shared/utils"

type WithdrawalModalCompletedProps = { onClose: () => void }

export default function WithdrawalModalCompleted({
  onClose,
}: WithdrawalModalCompletedProps) {
  const userAmount = useDappSelector(selectDepositActionUserAmount)
  const token = useDappSelector(selectDepositActionToken)
  const migrationStatus = useDappSelector(selectDepositActionMigrationStatus)

  if (!token) return null

  const tokenIcon = getTokenIcon(token)

  return (
    <Box w="720px" ml="11px" bg="primary.white.100" rounded="24px" p={10}>
      <Flex flexDir="column" gap={4}>
        <TokenLabel
          token={token}
          tokenIcon={tokenIcon}
          amount={userAmount}
          variant="large"
          isMigratedToTbtc={
            migrationStatus === DepositMigrationStatus.Completed
          }
        />
        <Flex m="59px 0 37px" alignItems="center" gap={4}>
          <Image src={checkIcon} />
          <Text variant="numbersL" color="green.highlight">
            Funds on their way
          </Text>
        </Flex>

        <Button
          mr="auto"
          variant="secondary"
          size="large"
          borderWidth={2}
          onClick={onClose}
        >
          close
        </Button>
      </Flex>
    </Box>
  )
}
